module.exports = __webpack_public_path__ + "static/media/premiere-pro.73b45f53.png";